import { api } from './client'
import type { Cart } from '@/types'

export const cartApi = {
  getCart: () => api.get<Cart>('/cart'),
  getCount: () => api.get<{ count: number }>('/cart/count'),
  addItem: (productId: string, quantity = 1) =>
    api.post<Cart>('/cart/items', { productId, quantity }),
  updateItem: (itemId: string, quantity: number) =>
    api.put<Cart>(`/cart/items/${itemId}`, { quantity }),
  removeItem: (itemId: string) => api.delete<Cart>(`/cart/items/${itemId}`),
  clearCart: () => api.delete<void>('/cart'),
  mergeCart: (items: { productId: string; quantity: number }[]) =>
    api.post<Cart>('/cart/merge', { items }),
  checkout: () =>
    api.post<{
      sessionUrl: string
      checkoutSessionId: string
      stripeSessionId?: string
      stub?: boolean
    }>('/checkout'),
}
